'use client';

import React from 'react';

import { Grid, GridProps } from './grid';

export interface SimpleGridProps extends Omit<GridProps, 'templateColumns'> {
  columns?: number | { base?: number; sm?: number; md?: number; lg?: number; xl?: number };
  minChildWidth?: string | number;
  spacing?: number | string;
  spacingX?: number | string;
  spacingY?: number | string;
}

export const SimpleGrid = React.forwardRef<HTMLDivElement, SimpleGridProps>(
  ({ columns, minChildWidth, spacing, spacingX, spacingY, children, ...props }, ref) => {
    // Handle responsive columns
    let templateColumns: string;

    if (minChildWidth) {
      templateColumns = `repeat(auto-fit, minmax(${minChildWidth}, 1fr))`;
    } else if (typeof columns === 'number') {
      templateColumns = `repeat(${columns}, 1fr)`;
    } else if (typeof columns === 'object') {
      // For now, use the base value or default to 1
      const baseColumns = columns.base || columns.sm || columns.md || columns.lg || columns.xl || 1;
      templateColumns = `repeat(${baseColumns}, 1fr)`;
    } else {
      templateColumns = 'repeat(1, 1fr)';
    }

    // Handle spacing
    const gap = spacing || undefined;
    const columnGap = spacingX || gap;
    const rowGap = spacingY || gap;

    return (
      <Grid
        ref={ref}
        templateColumns={templateColumns}
        gap={gap}
        columnGap={columnGap}
        rowGap={rowGap}
        {...props}
      >
        {children}
      </Grid>
    );
  }
);

SimpleGrid.displayName = 'SimpleGrid';
